import { Box, Typography } from "@mui/material";

import Link from "../../atoms/mui/Link";

import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";

// Documents Smart Upload filed carry the activity records they back
// (linkedTransactionIds, accumulated per filing target) -- this links each
// one to its transaction in the dashboard table (?id= opens its details).
const SmartUploadLinkedActivity = ({ linkedTransactionIds = [] }) => {
  const { rootPath = "/platform/company" } = usePlatformLayoutContext() || {};
  const count = linkedTransactionIds.length;

  if (!count) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
      <Typography variant="body2" color="textSecondary">
        Added by Smart Upload · Linked to {count} activity{" "}
        {count === 1 ? "record" : "records"}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {linkedTransactionIds.map((transactionId, index) => (
          <Link
            key={transactionId}
            href={`${rootPath}/dashboard?id=${transactionId}`}
            color="primary"
          >
            <Typography variant="caption">Record {index + 1}</Typography>
          </Link>
        ))}
      </Box>
    </Box>
  );
};

export default SmartUploadLinkedActivity;
